import { memo } from "react";

export default function TextDisplay(props) {

    return (
        <div className="display-text-container">
            <h2 className="top meme--text">{props.topText}</h2>
            <h2 className="bottom meme--text">{props.bottomText}</h2>
        </div>
    )
}